import { ToastrService } from 'ngx-toastr';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'bergh-upload-modal',
    templateUrl: './upload-modal.component.html',
    styleUrls: ['./upload-modal.component.scss'],
    standalone: false
})
export class UploadModalComponent implements OnInit {
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() upload: EventEmitter<File> = new EventEmitter();
  constructor(private _toastr: ToastrService) { }
  file: File;
  fileName: string = "";

  ngOnInit(): void {
  }

  onSelectFile(event) {
    const FILE = <File>event.target.files[0];
    const FORMATS = ['image/png','image/jpg','image/jpeg','application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    if(FORMATS.includes(FILE.type)){
      this.file = FILE;
      this.fileName = FILE.name;
    } else {
      this._toastr.warning('Je kunt alleen bestanden uploaden met de extensie .png, .jpg, .jpeg .pdf .doc .docx','Error')
    }
  }

  onSubmit() {
    if (this.file.size <= 15000000) {
      this.upload.emit(this.file);
    } else {
      this.file = null;
      this._toastr.warning('Bestandsgrootte moet kleiner zijn dan 15MB','Warning');
    }
  }
}
